module.exports = ".datepicker input {\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  margin-left: 7px; }\n\n.datepicker .calendar {\n  border: none;\n  height: 35px;\n  margin-left: 3px;\n  margin-top: -7px; }\n\n/deep/ .backdrop {\n  background: rgba(2, 0, 0, 0.85); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/age-verification/age-verification.component.scss
// module id = ./src/app/shared/components/age-verification/age-verification.component.scss
// module chunks = main